import Vue from 'vue';
import apiClient from '../../apiClient';

const state = {
  parts: []
};

const actions = {
  updatePartMarkup: (_context, { firmId, constructorId, partId, markup }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put(
          `/firms/${firmId}/constructors/${constructorId}/parts/${partId}/markup`,
          { markup }
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    })
};

const mutations = {
  partsList: (state, parts) => {
    Vue.set(state, 'parts', parts);
  }
};

export default {
  state,
  actions,
  mutations
};
